export const red = 'rgb(243,68,84)';
export const yellow = 'rgb(255,210,0)';
export const green = 'rgb(159,211,0)';

const interpolateColor = (color1, color2, factor) => {
    if (!factor) {
        factor = 0.5;
    }
    let result = color1.slice();
    for (let i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
    }
    return result;
}
//steps between Index0 & Index1 or Index1 & Index2
export const interpolateColors = (color1, color2, steps = 40) => {
    let stepFactor = 1 / (steps - 1),
        interpolatedColorArray = [];
    color1 = color1.match(/\d+/g).map(Number);
    color2 = color2.match(/\d+/g).map(Number);

    for (var i = 0; i < steps; i++) {
        interpolatedColorArray.push(interpolateColor(color1, color2, stepFactor * i));
    }

    return interpolatedColorArray;
}
export const getColor = (value, index0, index1, index2) => {

    if (value <= index0)
        return green;
    // -40 > - 60 && -40 < -30
    if (value > index0 && value < index1) {
        //60 +(-40) = 20
        let adjustedValue = Math.abs(index0) + value;
        let steps = Math.abs(index0) + index1;
        let c = interpolateColors(green, yellow, steps)[Math.min(Math.round(adjustedValue), steps - 1)];
        return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
    }
    if (value === index1)
        return yellow;
    if (value > index1 && value < index2) {
        let steps = Math.abs(index1) + index2;
        let c = interpolateColors(yellow, red, steps)[Math.round(value)];
        return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
    }
    if (value >= index2)
        return red;
}